export default "__VITE_ASSET__b0d4e55a__"